<template>
  <div class="container-fluid row">
    <div v-if="loading">
    <clip-loader :loading="loading" :color="color" :size="size"></clip-loader>
</div>
    <div v-else>
    <div class="card-body">
        <div class="row">
          <div class="col-md-12 mt-3">
            <h5 class="card-title">ต้นแบบข้อมูลห้องสอบและจำนวนผู้คุมสอบ</h5>
          </div>
          <div class="col-md-12">
            <button class="btn btn-sm btn-info">
              <div><a :href="prototype" style="color:white;text-decoration: none;"> ดาวน์โหลดต้นแบบ</a></div>
            </button>

          </div>
          <div class="col-md-3 mt-5">
            <label for="exampleInputEmail1" class="form-label">เลือกไฟล์สำหรับบันทึกข้อมูลลงระบบ</label>
            <input type="file"  accept=".xlsx, .xls" @change="onChangeC1" class="form-control-file" id="excelfileroom" />
            <button @click="savenew()" type="button" class="btn btn-success btn-sm mt-3">
              บันทึกข้อมูลลงในระบบ
            </button>
          </div>
        </div>
      </div>
    <div class="col-md-12 mb-3 mt-3" style="text-align: right">
      <a>
        <button type="button" id="get_file" class="btn btn-success btn-sm" @click="getid(0)" data-bs-toggle="modal"
          data-bs-target="#AddUser">
          <i class="fa fa-plus"></i> เพิ่มไฟล์
        </button></a>
    </div>
    <div class="col-md-12 mb-3 mt-3" style="margin: 15px;">
      <table class="table table-bordered">
        <thead>
          <tr class="table-active">
            <th scope="col">ลำดับที่</th>
            <th scope="col">ห้องสอบ</th>
            <th scope="col"> จำนวนผู้คุมสอบ (คน)</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody v-if="rooms.length == 0">
        <td style="text-align: center;" colspan="6">ไม่พบข้อมูล</td> 
        </tbody>
      <tbody v-else>
          <tr v-for="(l, i) in rooms" :key="i">
            <td>
              {{ i + 1 }}
            </td>
            <td>
              {{ l.room_name }}
            </td>
            <td>
              {{ l.count }}
            </td>
            <td>
              <a @click="getid(l.id)">
                <button type="button" class="btn btn-warning btn-sm" data-bs-toggle="modal" data-bs-target="#AddUser">
                  <i class="fa fa-edit"></i></button></a>&nbsp;
              <!-- <a @click="deletedata(l.id)">
              <button
                type="button"
                class="btn btn-danger btn-sm"
                data-bs-toggle="modal"
                data-bs-target="#DeleteStatus"
              >
                <i class="fa fa-trash"></i></button
            ></a> -->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  
    <!-- Modal -->
    <div class="modal fade" id="AddUser" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ title }}</h5>
            <button id="closeduser" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="card-body mt-3">
                <div class="form-group">
                  <div class="form-group">
                  <label for="username">ห้องสอบ</label>
                  <input
                    v-model="room.room_name"
                    type="text"
                    min="1"
                    class="form-control form-control-sm"
                    id="username"
                  />
                </div>
                <div class="form-group">
                  <label for="username">จำนวนผู้คุมสอบ</label>
                  <input
                    v-model="room.count"
                    type="text"
                    min="1"
                    class="form-control form-control-sm"
                    id="username"
                  />
                </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-success btn-sm" @click="save()">
              บันทึก
            </button>
            <button type="button" class="btn btn btn-secondary btn-sm" data-bs-dismiss="modal">
              ปิด
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="DeleteStatus" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">ยืนยันการลบข้อมูล</h5>
          </div>
          <div class="modal-footer mt-3">
            <button type="button" class="btn btn-danger btn-sm" @click="deletebyid()">
              <label>ลบข้อมูล</label>
            </button>
            <button id="closeddeleteuser" type="button" class="btn btn-secondary  btn-sm" data-bs-dismiss="modal">
              ปิด
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProctorService from "../services/ProctorService";
import FacultyService from "../services/FacultyService";
import CourseService from "../services/CourseService";
import FirstPageService from "../services/FirstPageService";
import LinkService from "../services/LinkService";
import axios from 'axios';
import RoomService from "../services/RoomService";
import readXlsxFile from "read-excel-file";
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

export default {
  name: "Nav",
  props: {
    msg: String,
  },
  components: {
    ClipLoader
  },
  data() {
    return {
      color: '#5bc0de',
      size: '50px',
      concert_id: 0,
      list: [],
      user: {},
      user_id: 0,
      hash: 0,
      title: "",
      roles: [],
      delete_id: 0,
      proctor: [],
      faculty: [],
      instructor: {},
      room: {},
      room_id: 0,
      instructor_id: 0,
      courselist: [],
      course: [],
      firstpagelist: [],
      file: '',
      link:'',
      pdfUrl: '',
      year:[],
      rooms:[],
      prototype:'',
      loading: false,
    };
  },
  mounted() {
    this.prototype = LinkService.getLink() + '/uploads/ต้นแบบข้อมูลห้องสอบและจำนวนผู้คุมสอบ.xlsx';
    this.getFaculty();
    this.getCourse();
    this.getFirstPage();
    this.link = LinkService.getLink()
    this.getRooms()
  },
  methods: {
    onChangeC1(event) {
      readXlsxFile(event.target.files[0]).then((data) => {
        this.file = data;

      });
    },
    getRooms() {
      RoomService.getRooms().then((res) => {
        this.rooms = res.data
        console.log(this.rooms);
      });

    },
    onChangePDF(evt) {
      const files = evt.target.files || evt.dataTransfer.files;
      if (!files.length) return;
      this.file = files[0];

    },
    onUploadFileChange() {
      const formData = new FormData();
      formData.append("file", this.file);
      var name = this.firstpage.year + '_' + this.firstpage.term + '_' + this.firstpage.exam_type + '.pdf'
      console.log(name);

      var http = LinkService.getLink() + '/uploadimage?name=' + name;
      axios
        .post(http, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(() => {
        })
    },
    getFirstPage() {
      FirstPageService.getFirstPages().then((res) => {
        this.firstpagelist = res.data
        console.log(this.firstpagelist);
      });

    },
    getCoursesByFaculty() {
      const courselist = this.course.filter(c =>
        c.faculty_id === this.filter.faculty_id
      );
      this.courselist = courselist;
    },
    getCourse() {
      CourseService.getCourses().then((res) => {
        this.course = res.data;
        this.courselist = res.data;
        console.log(res.data);
      });
    },
    getFaculty() {
      FacultyService.getFacultys().then((res) => {
        this.faculty = res.data;
        console.log(res.data);
      });
    },
    getProctor() {
      ProctorService.getProctors().then((res) => {
        this.proctor = res.data;
        console.log(res.data);
      });
    },
    deletedata(id) {
      this.delete_id = id;
    },
    getid(id) {
      this.room_id = id;
      if (this.room_id != 0) {
        this.title = "แก้ไขข้อมูล";
        RoomService.getRoom(this.room_id).then((res) => {
          this.room = res.data;
          this.pdfUrl = LinkService.getLink() + this.room.file_path
          console.log(this.pdfUrl);
          
        });
      } else {
        this.title = "เพิ่มข้อมูล";
        this.room = [];
      }
    },
    async getRoomByFilter(data) {
      const res = await RoomService.getRoomByFilter(data)
      return res.data;
    },
    async createRoom(room_id,file) {
      if (room_id == 0) {
        const res = await RoomService.createRoom({
        room_name: file.room_name,
        count: file.count
      });
      return res.data.id;
      }else{
      if (room_id !=0) {
        const res = await RoomService.updateroom(room_id,{
        room_name: file.room_name,
        count: file.count
      });
      return res.data;
      }}
    },
    async savenew() {
      if (this.file == "") {
        alert("กรุณาเลือกไฟล์ข้อมูลการคุมสอบก่อนนำเข้าข้อมูล");
      } else if (this.file.length > 0) {
        this.loading = true
        // var exist = []
        var room_id = ''
        for (let i = 1; i < this.file.length; i++) {
          console.log(this.file[i]);

          var room_name = this.file[i][0]
          var count = this.file[i][1]

          var roomlist = await this.getRoomByFilter({room_name:room_name})
          console.log('roomlist', roomlist);
          if (roomlist.length == 0) {
            room_id = 0
            await this.createRoom(room_id,{ room_name: room_name,count:count });
            // console.log('major_idd', major_id);
          } else {
            room_id = roomlist[0].id
            await this.createRoom(room_id, { room_name: room_name,count:count });
          }
          console.log('room_id', room_id);
          // break;
          if (i === this.file.length - 1) {
            this.loading = false
            alert("นำเข้าข้อมูลสำเร็จ");
            this.file = ''
            document.getElementById("excelfileroom").value = null
            this.getRoom()
          }
        }

      }
    },
    save() {
      if (this.room.room_name == null) {
        alert("กรุณากรอกชื่อห้องสอบ");
      } else if (this.room.count == null) {
        alert("กรุณากรอกจำนวนผู้คุมสอบ");
      } else {
        var roomdata = {
          room_name: this.room.room_name,
          count: this.room.count,
        };
        if (this.room_id == 0) {
          RoomService.createRoom(roomdata).then(() => {
              // console.log(res.data);
              this.getRooms()
              document.getElementById("closeduser").click();
          });
        } else {
          RoomService.updateroom(this.room_id, roomdata).then(() => {
            // console.log(res.data);
            document.getElementById("closeduser").click();
            this.getRooms()
          });
        }

      }
    },
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vertical-menu {
  background-color: #eee;
}

.vertical-menu a {
  background-color: #eee;
  color: black;
  display: block;
  padding: 12px;
  text-decoration: none;
}

.vertical-menu a:hover {
  background-color: #ccc;
}

.vertical-menu a.active {
  background-color: #04aa6d;
  color: white;
}

.card {
  margin: 0 auto;
  /* Added */
  float: none;
  /* Added */
  margin-bottom: 10px;
  /* Added */
}

body {
  background-color: gray;
}

hr {
  border: none;
  border-top: 1px solid #ccc;
  margin: 20px 0;
}

.row {
  margin-left: 0px;
  margin-right: 0px;
}
</style>